/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbLeadTime_item" | "PdpSharedBlurbReturns_item" | "PdpSharedBlurbShipping_item" | "PdpSharedBlurbUrgency_item" | "PdpSharedBlurbSupportNumber_item" | "PdpSharedBlurbPcs_item" | "consultAnExpert_item">;
    readonly " $refType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$data = PdpRespSidebarBlurbs_item;
export type PdpRespSidebarBlurbs_item$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbUrgency_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "consultAnExpert_item",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isJewelry",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "getCategoriesByLevel",
              "storageKey": "getCategoriesByLevel(level:2)",
              "args": [
                {
                  "kind": "Literal",
                  "name": "level",
                  "value": 2
                }
              ],
              "concreteType": "Category",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "label",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "pricing",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemPricing",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "totalAmount",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "convertedAmounts",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ConvertedAmounts",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "USD",
                          "args": null,
                          "storageKey": null
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'b6f4e2cab54cef1874b3d481ee6f9eca';
export default node;
